"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.validateArray = exports.validate = exports.findPropIgnoreCase = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _find = _interopRequireDefault(require("lodash/find"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var findPropIgnoreCase = function findPropIgnoreCase(obj, prop) {
  prop = (prop || '').toLocaleLowerCase();

  for (var property in obj) {
    if (property.toLocaleLowerCase() === prop) {
      return obj[property];
    }
  }
};

exports.findPropIgnoreCase = findPropIgnoreCase;

var validate = function validate(values, validator, value) {
  // return true in a validate function if we don't validate
  var validators = {
    isExisty: function isExisty(value, check) {
      return check && Array.isArray(value) ? value.length === 0 : !value && value !== 0 && value !== false;
    },
    maxLength: function maxLength(value, check) {
      return (value || '').length > check;
    },
    isTrue: function isTrue(value, check) {
      return value !== true;
    },
    matchRegexp: function matchRegexp(value, check) {
      var regex = new RegExp(check);

      if (!value) {
        return false;
      }

      if (!value.toString().match(regex)) {
        return true;
      }
    },
    isEmail: function isEmail(value, check) {
      if (value) {
        return !value.match(/^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
      }

      return false;
    },
    minLength: function minLength(value, check) {
      if (!value) {
        return false;
      }

      if (value.length < check) {
        return true;
      }
    },
    minValue: function minValue(value, check) {
      if (!(0, _isNil["default"])(value)) {
        var parseVal = parseFloat(value);

        if (!isNaN(parseVal) && !isNaN(check)) {
          return !(check < parseVal);
        }
      }

      return true;
    },
    maxValue: function maxValue(value, check) {
      if (!(0, _isNil["default"])(value)) {
        var parseVal = parseFloat(value);

        if (!isNaN(parseVal) && !isNaN(check)) {
          return !(check > parseVal);
        }
      }

      return true;
    },
    equals: function equals(value, check) {
      if (!value) {
        return false;
      }

      return check !== value;
    },
    equalsField: function equalsField(value, check) {
      if (!value) {
        return false;
      }

      return values[check] !== value;
    },
    isUrl: function isUrl(value, check) {
      if (value) {
        return !value.match(/^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i);
      }

      return false;
    },
    none: function none(value, check) {
      return false;
    },
    compareField: function compareField(value, check) {
      var compareOperator = validator && validator.extra && validator.extra.compare;
      var greaterThanOperatorStr = 'GreaterThan';
      var lessThanOperatorStr = 'LessThan';
      var greaterThanEqualOperatorStr = 'GreaterOrEqual';
      var lessThanEqualOperatorStr = 'LessThanOrEqual';

      if (compareOperator && value && values && values[check]) {
        var dateRegEx = /^\d{4}-\d{2}-\d{2}/;
        var currVal;
        var compVal; // if it is a string and have a valid date regex, we are going to convert the value to date first

        if (typeof value === 'string' && typeof values[check] === 'string' && value.match(dateRegEx) && values[check].match(dateRegEx)) {
          currVal = Number(new Date(values[check]));
          compVal = Number(new Date(value));
        } else {
          currVal = Number(values[check]);
          compVal = Number(value);
        }

        if (currVal && compVal && !Number.isNaN(currVal) && !Number.isNaN(compVal)) {
          switch (compareOperator) {
            case greaterThanOperatorStr:
              return !(compVal > currVal);

            case lessThanOperatorStr:
              return !(compVal < currVal);

            case greaterThanEqualOperatorStr:
              return !(compVal >= currVal);

            case lessThanEqualOperatorStr:
              return !(compVal <= currVal);

            default:
              return false;
          }
        }
      }

      return false;
    }
  }; // get the function

  var validatorFunc = findPropIgnoreCase(validators, validator.type);

  if (validatorFunc) {
    // if we dont validate, return error message
    if (validatorFunc(value, validator.value)) {
      return validator.error_message;
    }
  } else {
    console.error('Validator not found: ' + validator.type);
  }
};

exports.validate = validate;

var validateArray = function validateArray(values, validators, value) {
  if ((0, _isEmpty["default"])(validators)) {
    return;
  }

  var errors = validators.map(function (i) {
    return validate(values, i, value);
  });
  return (0, _find["default"])(errors, function (i) {
    return !!i;
  });
};

exports.validateArray = validateArray;
var _default = validateArray;
exports["default"] = _default;